"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsModalHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _dmsbasereact = require("dmsbasereact");
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
const _excluded = ["title", "onClose", "showCloseIcon"]; // DmsModalHeader.js
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * DmsModalHeader component
 * 
 * @param {object} props - Component props
 * @param {string} props.title - Title of the modal
 * @param {function} props.onClose - Function to call when the modal should be closed
 * @param {boolean} [props.showCloseIcon=true] - Determines whether the close button should be displayed
 * @returns {JSX.Element} The rendered header component
 */
const DmsModalHeader = _ref => {
  let {
      title,
      onClose,
      showCloseIcon = true
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_material.DialogTitle, props, title, showCloseIcon && /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsButton, {
    icon: /*#__PURE__*/_react.default.createElement(_Close.default, null),
    onClick: onClose,
    style: {
      float: 'right'
    }
  }));
};
exports.DmsModalHeader = DmsModalHeader;
DmsModalHeader.propTypes = _objectSpread({
  title: _propTypes.default.string.isRequired,
  onClose: _propTypes.default.func,
  showCloseIcon: _propTypes.default.bool
}, _material.DialogTitle.propTypes);